import Env from '../config/env';
import { getPaymentName, isBoleto } from '../utils/paymentType.utils';
import { minutesHumanize } from '../utils/time.utils';
import IcError from '../assets/icons/ic_error.svg';
import IcSuccess from '../assets/icons/ic_success.svg';
import IcWarning from '../assets/icons/ic_warning.svg';
import IcPix from '../assets/icons/ic_pix.svg';
import IcBoleto from '../assets/icons/ic_boleto.svg';

class AlertConstants {
  static error = {
    title: 'Ocorreu um erro inesperado',
    description:
      'Pedimos desculpas pela inconveniência. Por favor, tente novamente mais tarde.',
    buttonDescription: 'Tentar novamente',
    icon: IcError,
  };

  static notFoundReceipt = {
    title: 'Não encontramos nenhum comprovante',
    description: 'Não encontramos nenhum comprovante para o CPF informado',
    buttonDescription: 'Tentar novamente',
    icon: IcError,
  };

  static copiedBarcode = {
    title: 'O código de barras foi copiado com sucesso',
    description: 'Aguardamos o seu pagamento.',
    buttonDescription: 'OK',
    icon: IcSuccess,
  };

  static boletoNotFound = {
    title: 'Ocorreu um erro e não conseguimos baixar o boleto',
    description:
      'Pedimos desculpas pela inconveniência. Por favor, tente novamente mais tarde.',
    buttonDescription: 'Tentar novamente',
    icon: IcError,
  };

  static cancel(primaryAction: any) {
    return {
      title: 'Você quer cancelar esse pedido?',
      description:
        'Caso confirmar, o pedido será cancelado. Essa ação não pode ser desfeita.',
      buttonDescription: 'CANCELAR',
      buttonPrimaryDescription: 'CONFIRMAR',
      buttonPrimaryAction: primaryAction,
      backgroundColor: 'PRIMARY',
    };
  }

  static errorGenerateBoleto = {
    title: 'Ocorreu um erro e não conseguimos gerar o boleto',
    description:
      'Pedimos desculpas pela inconveniência. Por favor, tente novamente mais tarde.',
    buttonDescription: 'OK',
    icon: IcError,
  };

  static errorGeneratePix = {
    title: 'Ocorreu um erro e não conseguimos gerar o código Pix',
    description:
      'Pedimos desculpas pela inconveniência. Por favor, tente novamente mais tarde.',
    buttonDescription: 'OK',
    icon: IcError,
  };

  static errorRefusedPix = {
    title: 'Ocorreu um erro e não conseguimos gerar o código Pix',
    description:
      'Pedimos desculpas pela inconveniência. Por favor, contate o vendedor para que o pedido seja refeito.',
    buttonDescription: 'OK',
    icon: IcError,
  };

  static errorProductOutOfStock = {
    title:
      'Houve um problema, não há mais estoque disponível para o(s) produto(s) contidos na venda.',
    description:
      'Pedimos desculpas pela inconveniência. Por favor, contate o vendedor para que o pedido seja refeito.',
    buttonDescription: 'OK',
    icon: IcWarning,
  };

  static orderCannotBeCanceled = {
    title: 'O pedido não pode ser cancelado.',
    description: 'Não foi possível realizar o cancelamento do pedido, pois existe um pagamento pendente de confirmação.',
    buttonDescription: 'OK',
    icon: IcWarning,
  };

  static sellerDoesNotSellToCnpj = {
    title: 'Aviso',
    description: 'Transação não autorizada. Este Seller não aceita venda para CNPJ.',
    buttonDescription: 'OK',
    icon: IcWarning,
  };

  static orderExpireTime(
    title: string,
    timerAction: any,
    paymentId: string,
    linkExpirationInMinutes: number,
  ) {
    const linkExpiration = minutesHumanize(linkExpirationInMinutes);
    const paymentName = getPaymentName(paymentId);
    const timeToPayment = isBoleto(paymentId)
      ? '48 horas'
      : minutesHumanize(Env.PIX_MIN_TO_EXPIRED);

    return {
      title,
      description:
        `Esse link fica disponível por até ${linkExpiration} após a geração do pedido. ` +
        `Depois de gerar seu ${paymentName}, você ainda tem até ${timeToPayment} para fazer o pagamento!`,
      buttonDescription: 'OK',
      icon: isBoleto(paymentId)
        ? IcBoleto
        : IcPix,
      timerAction,
    };
  }
}

export default AlertConstants;
